(function () {
  var canvas = document.createElement('canvas');
  var ctx = canvas.getContext('2d', { willReadFrequently: true });
  var sampleFailed = false;
  var canvasReady = false;

  function isVisible(el) {
    var cs = getComputedStyle(el);
    if (cs.display === 'none' || cs.visibility === 'hidden') return false;
    if (parseFloat(cs.opacity) === 0) return false;
    return true;
  }

  function findHeroImage() {
    var main = document.querySelector('#MainContent, main');
    if (!main) return null;
    var imgs = main.querySelectorAll('img');
    var bestNearTop = null;
    var bestNearTopDist = Infinity;
    var bestAny = null;
    var bestAnyArea = 0;
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      if (img.closest('.sticky-add-to-cart')) continue;
      if (!isVisible(img)) continue;
      var rect = img.getBoundingClientRect();
      if (rect.top > window.innerHeight) continue;
      if (rect.width < 200 || rect.height < 200) continue;
      var area = rect.width * rect.height;
      if (area > bestAnyArea) {
        bestAnyArea = area;
        bestAny = img;
      }
      // Header'ın ARKASINDA duran görsel gerçekten sayfanın en tepesinden
      // başlamalı (top ~0). Ürün galerisi gibi yan yana kayan şeritlerde
      // birden fazla eşit adayı olabilir — bunların arasından gerçekten
      // o an ÇERÇEVELENMİŞ (sol kenarı x=0'a en yakın) olanı seçiyoruz,
      // ilk bulunanı ya da rastgele birini değil.
      if (rect.top <= 20) {
        var dist = Math.abs(rect.left);
        if (dist < bestNearTopDist) {
          bestNearTopDist = dist;
          bestNearTop = img;
        }
      }
    }
    return bestNearTop || bestAny;
  }

  // Her update() çağrısında SIFIRDAN bulunur ve canvas'a YENİDEN çizilir —
  // ürün fotoğrafı kaydırıldığında ya da header hydration ile DOM
  // değiştiğinde eski/bayat veri kullanılmasın diye.
  function drawFreshCanvas() {
    var heroImg = findHeroImage();
    if (!heroImg || !heroImg.complete || !heroImg.naturalWidth) {
      canvasReady = false;
      return null;
    }
    try {
      canvas.width = heroImg.naturalWidth;
      canvas.height = heroImg.naturalHeight;
      ctx.drawImage(heroImg, 0, 0);
      canvasReady = true;
      sampleFailed = false;
    } catch (e) {
      sampleFailed = true;
      canvasReady = false;
      return null;
    }
    return heroImg;
  }

  function sampleColorAt(heroImg, clientX, clientY) {
    if (sampleFailed || !canvasReady || !heroImg) return null;
    var rect = heroImg.getBoundingClientRect();
    if (clientX < rect.left || clientX > rect.right || clientY < rect.top || clientY > rect.bottom) {
      return 'out-of-bounds';
    }
    try {
      var scaleX = canvas.width / rect.width;
      var scaleY = canvas.height / rect.height;
      var px = Math.min(canvas.width - 1, Math.max(0, Math.round((clientX - rect.left) * scaleX)));
      var py = Math.min(canvas.height - 1, Math.max(0, Math.round((clientY - rect.top) * scaleY)));
      var data = ctx.getImageData(px, py, 1, 1).data;
      return { r: data[0], g: data[1], b: data[2] };
    } catch (e) {
      sampleFailed = true;
      return null;
    }
  }

  function luminance(c) {
    return 0.299 * c.r + 0.587 * c.g + 0.114 * c.b;
  }

  function isSubmenuOpen(header) {
    var submenus = header.querySelectorAll('.menu-list__submenu');
    for (var i = 0; i < submenus.length; i++) {
      if (!submenus[i].hasAttribute('inert')) return true;
    }
    return false;
  }

  function updateLogo(header, scrolled) {
    var defaults = header.querySelectorAll('.header-logo-img--default');
    var inverses = header.querySelectorAll('.header-logo-img--inverse');
    if (scrolled) {
      for (var i = 0; i < defaults.length; i++) defaults[i].style.setProperty('display', 'none', 'important');
      for (var j = 0; j < inverses.length; j++) inverses[j].style.setProperty('display', 'block', 'important');
    } else {
      for (var i2 = 0; i2 < defaults.length; i2++) defaults[i2].style.removeProperty('display');
      for (var j2 = 0; j2 < inverses.length; j2++) inverses[j2].style.removeProperty('display');
    }
  }

  function forceColor(header, color) {
    var els = header.querySelectorAll('.header-actions__action, .menu-list__link, .header__icon--menu');
    for (var i = 0; i < els.length; i++) {
      els[i].style.setProperty('color', color, 'important');
      var svgs = els[i].querySelectorAll('svg');
      for (var s = 0; s < svgs.length; s++) svgs[s].style.setProperty('stroke', color, 'important');
    }
  }

  function clearForcedColors(header) {
    var els = header.querySelectorAll('.header-actions__action, .menu-list__link, .header__icon--menu');
    for (var i = 0; i < els.length; i++) {
      els[i].style.removeProperty('color');
      var svgs = els[i].querySelectorAll('svg');
      for (var s = 0; s < svgs.length; s++) svgs[s].style.removeProperty('stroke');
    }
  }

  function forceLogoBlack(header) {
    var defaults = header.querySelectorAll('.header-logo-img--default');
    var inverses = header.querySelectorAll('.header-logo-img--inverse');
    for (var i = 0; i < defaults.length; i++) defaults[i].style.setProperty('display', 'block', 'important');
    for (var j = 0; j < inverses.length; j++) inverses[j].style.setProperty('display', 'none', 'important');
  }

  function sampleTopState(header) {
    var heroImg = drawFreshCanvas();
    var targets = header.querySelectorAll('.header-actions__action, .header-logo-slot, .menu-list__link, .header__icon--menu');
    for (var i = 0; i < targets.length; i++) {
      var el = targets[i];
      var rect = el.getBoundingClientRect();
      var color = heroImg ? sampleColorAt(heroImg, rect.left + rect.width / 2, rect.top + rect.height / 2) : null;
      if (color === null) continue;
      if (color === 'out-of-bounds') {
        el.classList.remove('bg-is-dark');
        el.classList.add('bg-is-light');
        continue;
      }
      var isDark = luminance(color) < 140;
      el.classList.toggle('bg-is-dark', isDark);
      el.classList.toggle('bg-is-light', !isDark);
    }
  }

  function clearTopState(header) {
    var targets = header.querySelectorAll('.header-actions__action, .header-logo-slot, .menu-list__link, .header__icon--menu');
    for (var i = 0; i < targets.length; i++) {
      targets[i].classList.remove('bg-is-dark', 'bg-is-light');
    }
  }

  function update() {
    var header = document.getElementById('header-component');
    if (!header) return;
    if (!header.hasAttribute('transparent') && !header.hasAttribute('data-reverse-transparent')) return;

    var dir = header.dataset.scrollDirection;
    var scrolled = dir === 'up' || dir === 'down';
    var submenuOpen = isSubmenuOpen(header);

    if (submenuOpen) {
      // Alt menü (beyaz panel) açıkken her şey SABİT SİYAH — ne scroll
      // durumuna ne de altındaki fotoğrafa bakılır.
      clearTopState(header);
      forceColor(header, '#000000');
      forceLogoBlack(header);
      return;
    }

    updateLogo(header, scrolled);

    if (scrolled) {
      clearTopState(header);
      forceColor(header, '#ffffff');
    } else if (!header.hasAttribute('data-keep-top-transparent')) {
      // Bu sayfada en üst şeffaf bir fotoğraf DEĞİL, düz (opak) bir zemin —
      // (ör. koleksiyon sayfası). Piksel örneklemeye hiç gerek yok, hep siyah.
      clearTopState(header);
      forceColor(header, '#000000');
    } else {
      clearForcedColors(header);
      sampleTopState(header);
    }
  }

  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update);
  setInterval(update, 300);
})();